import React, { useCallback } from 'react';
import classNames from 'classnames';
import { ThemeLogo, ThemeLogoType } from 'components/themeLogo';
import { openCenterModal } from 'lib/launchGame/utils';
import { isClientSide } from 'utility/constant';
import styles from './SportNavTotocalcio.module.scss';

export type SportNavTotocalcioProps = {
  image?: ThemeLogoType;
  linkLabel: string;
  className?: string;
  iframeWidth?: string;
  iframeHeight?: string;
};

export const SportNavTotocalcio = ({
  image,
  linkLabel,
  className,
  iframeWidth,
  iframeHeight,
}: SportNavTotocalcioProps) => {
  const handleLaunchTotoCalcio = useCallback(() => {
    if (isClientSide) {
      openCenterModal({
        url: `/login?urlSuccess=${encodeURIComponent('/totocalcio?&forceLogin=true')}&urlClose=${encodeURIComponent(
          '/sport/calcio'
        )}`,
        widthSize: iframeWidth ? `${iframeWidth}px` : '100%',
        heightSize: iframeHeight ? `${iframeHeight}px` : '100%',
      });
    }
  }, [iframeHeight, iframeWidth]);

  return (
    <div className={classNames(styles.container, className ?? '')}>
      <div className={styles.imageContainer}>
        <span className={styles.imageWrapper}>
          {image && (
            <ThemeLogo
              src={image.src}
              srcDarkMode={image.srcDarkMode}
              sizes="100vw"
              fill
              style={{ objectFit: 'cover' }}
              alt={image.alt}
              className={styles.image}
            />
          )}
        </span>
      </div>

      <button
        className={styles.link}
        onClick={() => {
          handleLaunchTotoCalcio();
        }}
      >
        {linkLabel}
      </button>
    </div>
  );
};